import find from 'lodash/find';
import get from 'lodash/get';
import filter from 'lodash/filter';
import includes from 'lodash/includes';

const copyright = (settings, paymentProviders) => {
  const defaultPaymentProvider = find(paymentProviders, ['config.isDefault', true]);
  if (+get(settings, 'preorder.copyright.enabled', '1') || get(defaultPaymentProvider, 'slug') === 'adyen') {
    try {
      return JSON.parse(settings['preorder.copyright']);
    } catch (e) {
      return {
        name: 'Vita Mojo',
        text: 'Powered by',
        link: 'http://vitamojo.com',
      };
    }
  }
  return null;
};

const storeSelectors = settings => {
  try {
    const storeSelectors = JSON.parse(get(settings, 'storeSelection.selectors', []));
    const preorderDeliveryOnly = +get(settings, 'preorder.delivery.only', 0);
    const showOpatMenus = +get(settings, 'show.opat.menus', 0);
    const preorderDeliveryEnabled = +get(settings, 'preorder.delivery.enabled', 0);
    const pickupDeliverySelectorEnabled = +get(settings, 'pickup.delivery.selector.enabled', 0);

    if (storeSelectors.length) return filter(storeSelectors, ({ enabled }) => enabled);

    return [
      {
        type: 'online',
        enabled: !preorderDeliveryOnly,
        default: true,
      },
      {
        type: 'delivery',
        enabled: preorderDeliveryOnly || preorderDeliveryEnabled || pickupDeliverySelectorEnabled,
      },
      {
        type: 'opat',
        enabled: showOpatMenus,
      },
    ].filter(({ enabled }) => enabled);
  } catch (e) {
    return [];
  }
};

const authAction = settings => {
  const createAction = get(settings, 'auth.action', null);
  if (!includes(['register', 'login'], createAction)) {
    return null;
  }
  return `auth.${createAction}`;
};

export const selectors = {
  copyright,
  storeSelectors,
  authAction,
};
